module.exports = __webpack_public_path__ + "static/media/nickles2.9538363c.jpg";